import axios from 'axios'

import { HANDLERS_ROUTES } from '../../constants'
import type { AirportDirectoryAirport } from '../../types/airport-directory'

export const getHandlerAirportBySlug = (slug: string) => axios.get(HANDLERS_ROUTES.GET_AIRPORTS_WITH_HANDLERS_BY_SLUG, {
    params: { slug },
})

export const getHandlerAirportByIcao = (icao: string) => axios.get(HANDLERS_ROUTES.GET_AIRPORTS_WITH_HANDLERS_BY_ICAO, {
    params: { icao },
})

export const searchAirportDirectory = (
    query: string,
    country: string,
    signal?: AbortSignal,
) => axios.get<AirportDirectoryAirport[]>(HANDLERS_ROUTES.SEARCH_AIRPORT_DIRECTORY, {
    params: { query, country },
    ...(signal ? { signal } : {}),
})
